
        <a [ngClass]="'table-cell-link'" [routerLink]="[this.path, rowData.siteId]">{{renderValue}}</a>
  


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/sites/sites-table/site-url-cell-render.component.ts.SiteUrlCellRenderComponent.html